/*
 * 缓存在localstorage的键值
 * 数据结构：namespace/key （模块命名空间 + 具体state键值）
 */
export default ['table/columnsCheckedAll', 'table/tempsLocalStore']



// WEBPACK FOOTER //
// ./src/store/plugins/cacheLocalKeys.js